<div class="visualizer-wrap">
  <h2>Fretboard Visualizer</h2>

  <div class="visualizer-controls">
    <button [class.active]="mode === 'notes'"     (click)="setMode('notes')">Notes</button>
    <button [class.active]="mode === 'chords'"    (click)="setMode('chords')">Chords</button>
    <button [class.active]="mode === 'scales'"    (click)="setMode('scales')">Scales</button>
    <button [class.active]="mode === 'intervals'" (click)="setMode('intervals')">Intervals</button>
  </div>

  <!-- Chord selector (root + variant) -->
  <div class="chord-selector" *ngIf="mode === 'chords'">
    <div class="root-list">
      <span *ngFor="let root of rootNotes"
            class="root-btn"
            [class.selected]="selectedRoot === root"
            (click)="onRootChange(root)">{{ root }}</span>
    </div>
    <div class="variant-list">
      <span *ngFor="let v of chordVariants"
            class="variant-btn"
            [class.selected]="selectedVariant === v.suffix"
            (click)="onVariantChange(v.suffix)">{{ v.label }}</span>
    </div>
  </div>

  <!-- Core / All toggle -->
  <div class="voicing-mode-toggle" *ngIf="mode === 'chords'">
    <button class="toggle-btn" [class.active]="!showAllVoicings" (click)="setVoicingMode(false)">
      Core Shapes <span class="toggle-count">{{ coreVoicings.length }}</span>
    </button>
    <button class="toggle-btn" [class.active]="showAllVoicings" (click)="setVoicingMode(true)">
      All Voicings <span class="toggle-count">{{ allVoicings.length }}</span>
    </button>
  </div>

  <!-- Voicing navigation -->
  <div class="voicing-nav" *ngIf="mode === 'chords'">
    <button class="nav-btn" (click)="prevVoicing()" [disabled]="currentVoicingIndex === 0">← Prev</button>
    <span class="voicing-label" *ngIf="totalVoicings > 0">
      {{ currentVoicingNumber }} of {{ totalVoicings }}
      <span class="voicing-pos">· {{ voicingPositionLabel }}</span>
    </span>
    <span class="voicing-label voicing-empty" *ngIf="totalVoicings === 0">No voicings found</span>
    <button class="nav-btn" (click)="nextVoicing()" [disabled]="currentVoicingIndex >= totalVoicings - 1">Next →</button>
  </div>

  <!-- Jump to scale -->
  <div class="go-to-scale" *ngIf="mode === 'chords'">
    <button class="go-scale-btn" (click)="goToScale()">View {{ selectedRoot }} scale →</button>
  </div>

  <!-- Scale selector -->
  <div class="scale-selector" *ngIf="mode === 'scales'">
    <div class="root-list">
      <span *ngFor="let root of rootNotes"
            class="root-btn"
            [class.selected]="selectedScaleRoot === root"
            (click)="onScaleRootChange(root)">{{ root }}</span>
    </div>
    <div class="scale-type-list">
      <span *ngFor="let s of scaleTypes"
            class="variant-btn"
            [class.selected]="selectedScaleType === s.suffix"
            (click)="onScaleTypeChange(s.suffix)">{{ s.label }}</span>
    </div>
  </div>

  <!-- Scale label / degree toggle -->
  <div class="voicing-mode-toggle" *ngIf="mode === 'scales'">
    <button class="toggle-btn" [class.active]="!showScaleDegrees" (click)="setScaleLabelMode(false)">Note Names</button>
    <button class="toggle-btn" [class.active]="showScaleDegrees" (click)="setScaleLabelMode(true)">Scale Degrees</button>
  </div>

  <!-- Scale view mode toggle -->
  <div class="voicing-mode-toggle" *ngIf="mode === 'scales'">
    <button class="toggle-btn" [class.active]="showAllScaleNotes" (click)="setScaleViewMode(true)">Full Neck</button>
    <button class="toggle-btn" [class.active]="!showAllScaleNotes" (click)="setScaleViewMode(false)">Positions</button>
  </div>

  <!-- Scale position navigation -->
  <div class="voicing-nav" *ngIf="mode === 'scales' && !showAllScaleNotes">
    <button class="nav-btn" (click)="prevScalePosition()" [disabled]="currentScalePositionIndex === 0">← Prev</button>
    <span class="voicing-label">
      {{ currentScalePositionNumber }} of {{ totalScalePositions }}
      <span class="voicing-pos">· {{ scalePositionLabel }}</span>
    </span>
    <button class="nav-btn" (click)="nextScalePosition()" [disabled]="currentScalePositionIndex >= totalScalePositions - 1">Next →</button>
  </div>

  <!-- Fretboard -->
  <div class="fretboard-grid">
    <div class="fretboard-row fretboard-header">
      <div class="fretboard-cell string-label"></div>
      <div class="fretboard-cell fret-label" *ngFor="let fret of frets">{{ fret }}</div>
    </div>
    <div class="fretboard-row" *ngFor="let string of strings; let stringIdx = index">
      <div class="fretboard-cell string-label">{{ string }}</div>
      <div class="fretboard-cell fret-cell"
           *ngFor="let fret of frets"
           [class.highlighted]="highlighted[stringIdx + '-' + fret]"
           (click)="onCellClick(stringIdx, fret)">
        <div class="string"></div>
        <span class="note-circle"
              [class.root-note]="mode === 'scales' && scaleNoteInfo[stringIdx + '-' + fret]?.isRoot">
          <ng-container *ngIf="mode === 'notes'">{{ getFretboardNotes()[stringIdx + '-' + fret] }}</ng-container>
          <ng-container *ngIf="(mode === 'chords') && highlighted[stringIdx + '-' + fret]">{{ getFretboardNotes()[stringIdx + '-' + fret] }}</ng-container>
          <ng-container *ngIf="mode === 'scales' && highlighted[stringIdx + '-' + fret]">
            {{ showScaleDegrees ? scaleNoteInfo[stringIdx + '-' + fret]?.degree : getFretboardNotes()[stringIdx + '-' + fret] }}
          </ng-container>
        </span>
      </div>
    </div>
  </div>

  <!-- Chord detection label (notes mode only) -->
  <div class="chord-label" *ngIf="mode === 'notes' && detectChord()">
    <strong>Chord:</strong> {{ detectChord() }}
  </div>
</div>
